// extracted by mini-css-extract-plugin
export default {"container":"heroSection_container__DUQrW","heroImage":"heroSection_heroImage__-0zYh"};